// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"7f3ac065","404":"f9181ddf"}[chunkId] + ".chunk.js";
};